(ns ui.view.transaction-process.cards.conditions
  (:require
   [common.transaction-process.resolver :as resolver]
   [re-frame.core :as rf]
   [ui.view.transaction-process.cards.card-header :as card-header]
   [ui.view.transaction-process.components.sub-entity-display :as sub-display]
   [ui.view.transaction-process.sub :as sub]
   [ui.view.transaction-process.util :as tp-util]))

(defn condition-source
  "Return the condition collection metadata for a resolved attestation or
  decision slot. Slots without an instance or condition refs are omitted."
  [{:keys [entry instance] :as slot}]
  (let [category (resolver/slot-category entry)
        conditions-field (case category
                           :attestations :attestation/conditions
                           :decisions :decision/conditions
                           nil)]
    (when (and instance
               conditions-field
               (seq (get instance conditions-field)))
      (assoc slot
             :conditions-field conditions-field
             :show-status? (= :attestations category)))))

(defn- source-view
  [{:keys [source can-write-attestation-condition?]}]
  (let [{:keys [entry instance conditions-field show-status?]} source]
    [:div {:class "border border-gray-200 rounded-lg p-4"}
     [:span {:class "text-sm m-0 font-medium text-gray-900 block mb-3"}
      (:slot/label entry)]
     [sub-display/conditions-list
      {:entity instance
       :conditions-field conditions-field
       :can-write? (and show-status? can-write-attestation-condition?)
       :show-status? show-status?
       :show-label? false}]]))

(defn view
  [{:keys [card ctx]}]
  (let [matched-attestations @(rf/subscribe [::sub/matched-attestations ctx])
        matched-decisions @(rf/subscribe [::sub/matched-decisions ctx])
        can-write-attestation-condition? @(rf/subscribe
                                           [::sub/can-write-field?
                                            ctx
                                            :attestation-condition/status])
        by-slot (->> (concat matched-attestations matched-decisions)
                     (map (fn [slot] [(:slot-kw slot) slot]))
                     (into {}))
        sources (->> (:card/slots card)
                     (keep by-slot)
                     (keep condition-source)
                     (filter (fn [{:keys [instance conditions-field]}]
                               (seq (tp-util/resolve-refs
                                     (get instance conditions-field)))))
                     vec)]
    (when (seq sources)
      [:div {:class "bg-white rounded-lg border border-gray-200 p-6"}
       [card-header/view {:card card}]
       [:div {:class "flex flex-col gap-3"}
        (doall
         (for [source sources]
           ^{:key (:slot-kw source)}
           [source-view
            {:source source
             :can-write-attestation-condition? can-write-attestation-condition?}]))]])))
